// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function ChartLineDownIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29 26a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 2 0v1.586l7 7 3.293-3.293a1.001 1.001 0 0 1 1.415 0L24 18.585V16a1 1 0 0 1 2 0v5a.878.878 0 0 1 0 .1c0 .014 0 .026-.006.04-.006.014 0 .037-.009.058a.346.346 0 0 1-.011.046c0 .016-.008.032-.013.049l-.015.043-.017.049-.019.039c-.008.016-.015.034-.024.05-.008.016-.014.022-.02.035l-.03.049-.026.035-.032.043c-.014.018-.03.034-.045.05l-.02.023-.022.018a.606.606 0 0 1-.092.078l-.038.027-.047.03a.34.34 0 0 1-.038.02l-.046.024-.043.019-.044.016a.346.346 0 0 1-.048.017l-.045.012c-.017 0-.032.009-.05.011l-.052.009-.044.006a.905.905 0 0 1-.099 0H20a1 1 0 0 1 0-2h2.586L16 13.414l-3.293 3.293a1.001 1.001 0 0 1-1.415 0L5 10.415V25h23a1 1 0 0 1 1 1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
